export const SEARCH_MIN_CHARS = 3;
export const DEFAULT_NETWORK_MAX_CONNECTIONS = 29;
export const REQUEST_HARDWARE_URL =
  'https://app.smartsheet.com/b/form/5b9080f6a5d14a70b8668bdf9b916e8a';
export const REQUEST_VM_URL =
  'https://cisco-gde.atlassian.net/servicedesk/customer/portal/2/create/4388';
